// extracted by mini-css-extract-plugin
module.exports = {"undoDescription":"styles_undoDescription__C5fNw","undoAction":"styles_undoAction__Idksd","undoLink":"styles_undoLink__7nB_D","undoIcon":"styles_undoIcon__xRDit"};